// Default Gray design
const DefaultGrayDesign = {
  id: 'default-gray',
  name: 'Default Gray',
  category: 'default', // Set category
  description: 'Minimalist grayscale design',
  colors: {
    primary: "#555555",    // Medium Gray
    secondary: "#777777",  // Lighter Gray (for borders/icons if style overridden)
    tertiary: "#999999",   // Light Gray
    quaternary: "#bbbbbb", // Very Light Gray
    accent1: "#555555",    // Medium Gray
    accent2: "#555555",    // Medium Gray
    // ... add other accents as gray if needed
    text: "#333333",       // Dark Gray Text
    textSecondary: "#777777", // Lighter Gray Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#ffffff", // White sidebar
    border: "#dddddd",     // Very light gray border
  },
};

export default DefaultGrayDesign; 